<template>

  <panel-navigation>

    <dialog-add-review ref="dialogAddReview"></dialog-add-review>
    <dialog-request-review ref="dialogRequestReview"></dialog-request-review>

    <!-- <div class="float-right ml-5 -mt-1">
      <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogAddReview.show()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"> </i> ADD REVIEW MANUALLY</div>
    </div> -->

  <div v-if="me && me.company_type == 'agency' && businesses" class="rg-top-filter float-right mr-5" style="margin-top: -10px; min-width: 300px; max-width: 300px;">

      <v-select
          v-model="selected_clients"
          :items="businesses"
          item-text="company_name"
          item-value="id"
          multiple
          outlined
          dense
          style="background: #FFFFFF;"
          append-icon="mdi-chevron-down"
          hide-details
          small-chips
          placeholder="Filter By Client"

          v-show="!$vuetify.breakpoint.mobile"
          >
          <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0 || index === 1">
              <span>{{ item.company_name }}</span>
              </v-chip>
              <span
              v-if="index === 2"
              class="grey--text text-caption"
              >
              (+{{ selected_clients.length - 2 }} more)
              </span>
          </template>
      </v-select>
  </div>

  <div v-if="me && me.company_type == 'agency' && businesses && !$vuetify.breakpoint.mobile" class="rg-top-filter float-right mr-5" style="margin-top: -2px;">
    <a class="text-sm" href="javascript: void(0);" @click="selectAllClients()">Select All</a> / <a class="text-sm" href="javascript: void(0);" @click="unSelectAllClients()">Clear All</a>
  </div>

    <div v-if="me && (me.request_reviews_access || !isAccelerate())" class="float-right ml-5 -mt-1">
        <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogRequestReview.show();" style="margin-top: 4px"><i class="fa fa-plus mr-2"> </i> REQUEST REVIEWS</div>
    </div>
    
    <h1 class="text-lg font-semibold mb-3">Reviews</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full">
      <v-card
        class="pa-2"
        tile
      >
        <div class="p-3">
          <div class="reviews-section-wrapper">
            <ReviewsTableOld dashboard="true" v-if="$vuetify.breakpoint.mobile" /> 
            <ReviewsTable v-else :selected_clients="selected_clients" :key="reviewsTableKey" />
          </div>
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import ReviewsTable from '@/components/ReviewsTable.vue'
import DialogAddReview from '@/components/dialogs/reviews/addReview.vue'
import DialogRequestReview from '@/components/dialogs/reviews/requestReview.vue'
import ReviewsTableOld from '@/components/ReviewsTableOld.vue'

export default {
  metaInfo () {
    return {
      title: "Reviews | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      businesses: state => state.businesses.businesses,
      fetchingBusinesses: state => state.businesses.fetchingBusinesses,
      me: state => state.me.me,
    })
  },

  components: {
    PanelNavigation,
    ReviewsTable,
    DialogAddReview,
    DialogRequestReview,
    ReviewsTableOld
  },

  data () {
    return {
      reviewsTableKey: 0,
      selected_clients: []
    }
  },

  methods: {
    getHost() {
      return window.location.host;
    },

    isOnlyAi() {
      if (this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.status == 0)
        return true;

      return false;
    },

    isAccelerate() {
      // || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
      // || this.getHost() == 'localhost:8080'
      return this.getHost() == 'lsa.accelerateyourmarketing.com';
    },
    
    refreshReviews() {
      this.reviewsTableKey++;
    },
    selectAllClients() {
      let all_ids = [];

      for (var i in this.businesses) {
        all_ids.push(this.businesses[i].id);
      }

      this.selected_clients = all_ids;
    },
    unSelectAllClients() {
      this.selected_clients = [];
    }
  },

  created() {
    this.$store.dispatch('businesses/fetch')

    let selectedClients = localStorage.getItem('reviews_selected_clients');

    // console.log('selectedClients', selectedClients)
    
    if (selectedClients) {
      selectedClients = selectedClients.split(",");
      for (var i in selectedClients) {
        selectedClients[i] = parseInt(selectedClients[i]);
      }
      this.selected_clients = selectedClients;
    }
  },

  watch: {
    selected_clients: {
      handler () {
        // console.log(this.selected_clients)
        localStorage.setItem('reviews_selected_clients', this.selected_clients.join(","));

        this.refreshReviews();
      }
    }
  }
}
</script>

<style>
  .reviews-section-wrapper .pa-2.v-card {
    border: 0px;
  }
</style>